
import { useSelector } from "react-redux"
import styled from "styled-components"

import yukEkleDark from "../../../../images/svg/colors/dark/yukEkle.svg"
import yuklerListesiDark from "../../../../images/svg/colors/dark/yukler-listesi-dark.svg"
import atananlarDark from "../../../../images/svg/colors/dark/surucu-onayinda-dark.svg"
import yuklemedeDark from "../../../../images/svg/colors/dark/yuklemede-dark.svg"
import seferdeDark from "../../../../images/svg/colors/dark/seferde-dark.svg"
import bosaltmadaDark from "../../../../images/svg/colors/dark/bosaltmada-dark.svg"
import tamamlananSeferlerDark from "../../../../images/svg/colors/dark/tamamlanan-seferler-dark.svg"

import yukEkleLight from "../../../../images/svg/colors/light/yukEkle.svg"
import yuklerListesiLight from "../../../../images/svg/colors/light/yukler-listesi-light.svg"
import atananlarLight from "../../../../images/svg/colors/light/surucu-onayinda-light.svg"
import yuklemedeLight from "../../../../images/svg/colors/light/yuklemede-light.svg"
import seferdeLight from "../../../../images/svg/colors/light/seferde-light.svg"
import bosaltmadaLight from "../../../../images/svg/colors/light/bosaltmada-light.svg"
import tamamlananSeferlerLight from "../../../../images/svg/colors/light/tamamlanan-seferler-light.svg"
import { NavLink } from "react-router-dom"

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: calc(100% - 60px);
    padding: 15px;
    border: 1px solid ${({theme}) => theme.mainBorderColor};
    border-radius: 10px;
    margin: 5px 30px;

    .menu-item{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 10px;
        height: 70px;
        border-radius: 10px;

        .img{
            width: 22px;
            height: 22px;
        }

        .text, .quantity{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            margin: 2px 0;
        }

        .notification-text{
            color: var(--color-main);
            font-weight: var(--font-weight-lg);
            font-size: 12px;
            padding-bottom: 3px;
        }

        &:first-child{
            /* border: 1px solid ${({theme}) => theme.mainTextColor}; */
        }
    }

    .active{
        border: 1px solid var(--color-main);
    }

    @media (max-width: 1550px) {
        .text{
            display: none;
        }

        .quantity{
            padding-top: 5px;
        }
    }

`

const TopbarMenulerSm = () => {

    const {topPagesNotificationsCounts, topPagesCounts} = useSelector(state => state.notification)
    const { theme } = useSelector((state) => state.layout);
    const {atananlarListQuantity} = useSelector(state => state.loadList)

    const items = [
        {
            id:0,
            text:"Yük Ekle",
            path: "/yuk-ekle",
            smText: "Yük Ekle",
            imgDark:yukEkleDark,
            imgLight: yukEkleLight,
            quantity: topPagesCounts?.yukListesiSayisi,
            isShRl: false
        },
        {
            id:1,
            text:"Yükler Listesi",
            smText: "Yükler",
            path: "/yukler-listesi",
            imgDark:yuklerListesiDark,
            imgLight: yuklerListesiLight,
            quantity: topPagesCounts?.yukListesiSayisi,
            //   notifications: null
            isShRl: false
        },
        {
            id:2,
            text:"Atananlar",
            smText: "Atananlar",
            imgDark:atananlarDark,
            imgLight: atananlarLight,
            path: "/atananlar",
            quantity: atananlarListQuantity ?? topPagesCounts?.shipmentAtananSayisi ?? topPagesCounts?.atananlarSayisi ?? topPagesCounts?.surucuOnayındakiTeklifSayisi ?? 0,
            notifications: topPagesNotificationsCounts?.driverApprovedAspire,
            isShRl: false
        },
        {
            id:4,
            text:"Yüklemede",
            smText: "Yüklemede",
            imgDark:yuklemedeDark,
            imgLight: yuklemedeLight,
            path: "/yuklemede",
            quantity: topPagesCounts?.shipmentYuklemedeSayisi,
            notifications: topPagesNotificationsCounts?.onLoad,
            isShRl: false
        },
        {
            id:5,
            text:"Seferde",
            smText: "Seferde",
            imgDark:seferdeDark,
            imgLight: seferdeLight,
            path: "/seferde",
            quantity: topPagesCounts?.shipmentSeferdeSayisi,
            notifications: topPagesNotificationsCounts?.onShipment,
            isShRl: false
        },
        {
            id:6,
            text:"Boşaltmada",
            smText: "Boşaltmada",
            imgDark:bosaltmadaDark,
            imgLight: bosaltmadaLight,
            path: "/bosaltmada",
            quantity: topPagesCounts?.shipmentBoşaltmadaSayisi,
            notifications: topPagesNotificationsCounts?.onUnload,
            isShRl: false
        },
        {
            id:7,
            text:"Tamamlanan Seferler",
            smText: "Tamamlanan",
            imgDark:tamamlananSeferlerDark,
            imgLight: tamamlananSeferlerLight,
            path: "/tamamlanan-seferler",
            quantity: topPagesCounts?.shipmentTamamlanananSayisi,
            notifications: topPagesNotificationsCounts?.shipmentCompleted,
            isShRl: false
        },
    ]

  return (
    <Container>
            {items.map((item,i)=> (
                <NavLink
                    key={item.id}
                    to={item.path}
                    className={({ isActive }) =>
                    isActive ? "active menu-item" : "menu-item"
                    }
                >
                    <div className="notification-text" style={{paddingTop: (i === 0 || i === 1) && "15px" }}>{item.notifications}</div>
                    <img src={theme === "dark" ? item.imgLight : item.imgDark} className="img"/>
                    <div className="text">{item.smText}</div>
                    <div className="quantity" style={{visibility: item.path === "/yuk-ekle" && "hidden"}}>{item.quantity}</div>
                </NavLink>
            ))}
        
    </Container>
  )
}

export default TopbarMenulerSm
